import {
  UpdateIconButton,
  formatCurrency,
  formatDate,
  LockedIcon,
  pn,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@compass/core";

import { ListBeProperty } from "components";
import {
  NonPersonnelListDto,
  NonPersonnelListResource,
  Permission,
  PermissionAction,
  SortObject,
} from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { nonPersonnelPageRoute } from "../NonPersonnelPage/NonPersonnelPage";

export const NonPersonnelTable = (props: {
  tableContainerRef: React.RefObject<HTMLDivElement>;
  rootPermission: Permission;
  nonPersonnels: NonPersonnelListDto[];
  resource: NonPersonnelListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<NonPersonnelListDto>("date"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<NonPersonnelListDto>("partner"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<NonPersonnelListDto>("subPartner"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell align="right">
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<NonPersonnelListDto>("totalAmount"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell align="center">
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<NonPersonnelListDto>("files"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.nonPersonnels.map((nonPersonnelItem) => (
            <TableRow
              key={nonPersonnelItem.id}
              onClick={() => navigate(nonPersonnelPageRoute.getPath({ id: nonPersonnelItem.id, crudMode: "view" }))}
            >
              <TableCell>{formatDate(nonPersonnelItem.date)}</TableCell>
              <TableCell>{nonPersonnelItem.partner}</TableCell>
              <TableCell>{nonPersonnelItem.subPartner}</TableCell>
              <TableCell align="right">{formatCurrency(nonPersonnelItem.totalAmount)}</TableCell>
              <TableCell align="center">{nonPersonnelItem.files}</TableCell>
              <TableCell type="action">
                {nonPersonnelItem.isLocked === true && <LockedIcon />}

                {isAuthorized(props.rootPermission, PermissionAction.Update) &&
                  (!nonPersonnelItem.isLocked || isAuthorized(props.rootPermission, PermissionAction.Lock)) && (
                    <UpdateIconButton
                    color="primary"
                      onClick={() =>
                        navigate(nonPersonnelPageRoute.getPath({ id: nonPersonnelItem.id, crudMode: "edit" }))
                      }
                    />
                  )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
